import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';
// import Rellax from 'rellax';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        function onScroll({ direction, scroll }) {
            if (scroll < 40) {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.remove('is-scrolling-down');
            } else if (direction === -1) {
                document.querySelector('html').classList.add('is-scrolling-up');
                document.querySelector('html').classList.remove('is-scrolling-down');
            } else if (direction === 1) {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.add('is-scrolling-down');
            } else {
                document.querySelector('html').classList.remove('is-scrolling-up');
                document.querySelector('html').classList.add('is-scrolling-down');
            }
            if (scroll > 40) {
                document.querySelector('html').classList.add('has-header-fixed');
            } else {
                document.querySelector('html').classList.remove('has-header-fixed');
            }
        }

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

		window.addEventListener('footerIsVisible', (e) => {
			const { target, way, from } = e.detail;
			if (way === 'enter') {
				document.querySelector('html').classList.add('footer-is-visible');
			} else if (way === 'leave') {
				document.querySelector('html').classList.remove('footer-is-visible');
			} else {
				document.querySelector('html').classList.remove('footer-is-visible');
			}
		});

        window.addEventListener('topAnchorIsVisible', (e) => {
			const { target, way, from } = e.detail;
			if (way === 'enter') {
				document.querySelector('html').classList.add('quickanchornav-is-visible');
			} else if (way === 'leave') {
				document.querySelector('html').classList.remove('quickanchornav-is-visible');
			} else {
				document.querySelector('html').classList.remove('quickanchornav-is-visible');
			}
		});
    }

    scrollToEl(attr) {
        window.locomotiveScroll.scrollTo(attr.element, attr.options);
    }

    destroy() {
        super.destroy();
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
    }
}